var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24999 13H10.1667C11.175 13 12 12.1 12 11V1H4.19917C2.82417 1 1.62334 1.82999 1 3.04999",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.3478C1 15.08 1.32939 17 2.93757 17H3.70996C3.70996 15.8522 4.77825 14.913 5.84391 14.913C6.90957 14.913 7.70996 15.8522 7.70996 17H11.6566C11.6566 15.8522 12.5285 14.913 13.5942 14.913C14.6598 14.913 15.71 15.8522 15.71 17H16.0937C17.7018 17 19 15.6017 19 13.8696V13.3478H16.0937C15.5608 13.3478 15.21 13.0739 15.21 12.5V9.36957C15.21 8.79565 15.9677 8.13043 16.5005 8.13043H17.7502L16.0937 6.05392C15.5317 5.52174 15.1055 5 14.408 5H12.6254V11.2609C12.6254 12.4087 11.7535 13.3478 10.6878 13.3478H9.71904",
    fill: "#00A651"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.3478C1 15.08 1.32939 17 2.93757 17H3.70996C3.70996 15.8522 4.77825 14.913 5.84391 14.913C6.90957 14.913 7.70996 15.8522 7.70996 17H11.6566C11.6566 15.8522 12.5285 14.913 13.5942 14.913C14.6598 14.913 15.71 15.8522 15.71 17H16.0937C17.7018 17 19 15.6017 19 13.8696V13.3478H16.0937C15.5608 13.3478 15.21 13.0739 15.21 12.5V9.36957C15.21 8.79565 15.9677 8.13043 16.5005 8.13043H17.7502L16.0937 6.05392C15.5317 5.52174 15.1055 5 14.408 5H12.6254V11.2609C12.6254 12.4087 11.7535 13.3478 10.6878 13.3478H9.71904H1Z",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80957 19C6.91414 19 7.80957 18.1046 7.80957 17C7.80957 15.8954 6.91414 15 5.80957 15C4.705 15 3.80957 15.8954 3.80957 17C3.80957 18.1046 4.705 19 5.80957 19Z",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 19C14.8145 19 15.71 18.1046 15.71 17C15.71 15.8954 14.8145 15 13.71 15C12.6054 15 11.71 15.8954 11.71 17C11.71 18.1046 12.6054 19 13.71 19Z",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11V13.3618H16.1429C15.5143 13.3618 15 12.9118 15 12.3618V9C15 8.45 15.5143 8 16.1429 8H17.71L19 11Z",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.642d08c8c44ddff294b5ef4cba049139.svg";
export { ForwardRef as ReactComponent };